// @flow
import * as React from "react";
import type { TicketReservation } from "../../common/types";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Chip from "@material-ui/core/Chip";
import DoneIcon from "@material-ui/icons/Done";
import Label from "../../components/Label";
type Props = {
  ticketReservation: TicketReservation,
  setTicketReservation: Function,
  setStep: Function,
};

function GameAdminSmartCheckInFormListItem({
  ticketReservation,
  setTicketReservation,
  setStep,
}: Props) {
  const {
    id,
    amount,
    amountRedeemed = 0,
    paymentStatus = "INCOMPLETE",
  } = ticketReservation;

  const checkin = async () => {
    await setTicketReservation(ticketReservation);
    setStep(2);
  };

  return (
    <ListItem button onClick={checkin}>
      <ListItemText
        primary={ticketReservation.userName}
        secondary={
          <>
            {paymentStatus === "COMPLETE" && (
              <Label label="Bezahlt" color="success" />
            )}{" "}
            {id.toUpperCase()}
          </>
        }
      />
      {amountRedeemed > 0 ? (
        <ListItemSecondaryAction>
          {amount > amountRedeemed ? (
            <Chip
              label={`${amountRedeemed}/${amount}`}
              onClick={checkin}
              clickable
              color="primary"
              variant="outlined"
            />
          ) : (
            <DoneIcon color="primary" />
          )}
        </ListItemSecondaryAction>
      ) : amount > 1 ? (
        <ListItemSecondaryAction>
          <Chip
            label={`${amount} Tickets`}
            onClick={checkin}
            clickable
            color="secondary"
            variant="outlined"
          />
        </ListItemSecondaryAction>
      ) : null}
    </ListItem>
  );
}

export default GameAdminSmartCheckInFormListItem;
